import { render, staticRenderFns } from "./ViewsVerify.vue?vue&type=template&id=20b60c56&"
import script from "./ViewsVerify.vue?vue&type=script&lang=js&"
export * from "./ViewsVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports